module.exports = __webpack_public_path__ + "media/images/icons/large-arrow-down-left-c385a7668fdba90f3604a3e75d334c59.svg";